import React from "react";
import {
  MainCenter,
  Woman,
  ThirdContainer,
  ThirdTitle,
  BackBtn,
  SecondContainer,
  MainTitle,
  SecondTitle,
  ContainerHeadings,
  Bar,
} from "./style";
import useView from "../../hooks/useView";
import config from "../../config/enviroment"
import { language } from "../../utils/language";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/reducers/index";

const Inactive = () => {
  const { width } = useView();
  const homeState: HomeStateType = useSelector(
		(state: RootState) => state.home
	);

  const displayInformation = {
    title: language[homeState.default_language]["catalogueInactive"],
    message1: language[homeState.default_language]["messageInactiveCatalogue"],
    message2: language[homeState.default_language]["messageInactiveCatalogue2"],
    message3: language[homeState.default_language]["createAccount"],
    message4: language[homeState.default_language]["learnMore"],
  };

  return (
    <>
      <MainCenter>
        <SecondContainer>
          <Woman src={`${config.urlMultimedia}/vende/landing-img/woman.jpg`}></Woman>
          <Bar />
          <ContainerHeadings>
            <MainTitle>{displayInformation.title}</MainTitle>
            <ThirdContainer>
              {width < 1100 ? (
                <SecondTitle>
                  {displayInformation.message1} <br></br>
                  {displayInformation.message2}
                </SecondTitle>
              ) : (
                <SecondTitle>
                  {displayInformation.message1} <br></br>
                  {displayInformation.message2}
                </SecondTitle>
              )}

              <ThirdTitle>
               {displayInformation.message3}
              </ThirdTitle>
              <BackBtn
                onClick={() => window.location.replace("https://epayco.com")}
              >
                {displayInformation.message4}
              </BackBtn>
            </ThirdContainer>
          </ContainerHeadings>
        </SecondContainer>
      </MainCenter>
    </>
  );
};

export default Inactive;
